import { render, staticRenderFns } from "./NaoxjStockStock.vue?vue&type=template&id=6807dc78&scoped=true&"
import script from "./NaoxjStockStock.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockStock.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockStock.vue?vue&type=style&index=0&id=6807dc78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807dc78",
  null
  
)

export default component.exports